import { useCallback, useRef, useState } from 'react';

import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import FlexMainWrapper, { Wrapper02 } from '../../designComponents/wrappers/FlexMainWrapper';
import MainTable from '../../designComponents/tables/MainTable';
import { availFilter, roleFilter } from '../../utils/textFilter';
import { gatheringChatFilter } from '../../components/ChattingComponents/ChattingTableFilter';
import { ChatModalComponent } from '../../designComponents/modals/ModalComponent';
import ServerChatDetail from '../../components/ChattingComponents/ServerChatDetail';
import { formatChatTimestamp } from '../../data_system/data_functions/chatting_date_function/chatting_date_function';
import { MText } from '../../designComponents/text/ContentText';
import SearchbarWithDropdown from '../../designComponents/searchbars/SearchbarWithDropdown';
import { getChattingListRequest } from '../../api/main/chatting/ChattingRequest';

/** 모임채팅 페이지 */
const GatheringChat = () => {
    const [param, setParam] = useState({ order: -1 });
    const [searchType, setSearchType] = useState(1);
    const [searchText, setSearchText] = useState('');

    const [chatParams, setChatParams] = useState({ toggle: false });

    const ref = useRef(null);
    const tableRef = useRef(null);

    const callApi02 = async (page, param) => {
        try {
            /** 1: 친구, 2: 모임, 3: 모임단체 */
            const input = {
                type: 2,
                page: page,
                size: 10,
                ...param,
            };
            if (searchType === 1) {
                input.phone = searchText;
            } else if (searchType === 2) {
                input.userName = searchText;
            } else if (searchType === 3) {
                input.nickName = searchText;
            } else if (searchType === 4) {
                input.name = searchText;
            }
            const response = await getChattingListRequest(input, 2);

            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Wrapper02>
            <MainPageTitle text={'모임 대화방'} onClick={() => ref?.current?.refresh()} />
            <SearchbarWithDropdown
                list={[
                    { id: 1, title: '휴대폰번호', value: 1 },
                    { id: 2, title: '이름', value: 2 },
                    { id: 3, title: '닉네임', value: 3 },
                    { id: 4, title: '모임명', value: 4 },
                ]}
                resetThenSet={useCallback((item) => {
                    setSearchType(item.value);
                }, [])}
                onChangeSubmit={(e) => {
                    e.preventDefault();
                    ref?.current?.refresh();
                }}
                searchText={searchText}
                onChangeInput={(e) => {
                    const value = e.target.value;
                    setSearchText(searchType === 1 ? value.replaceAll('-', '') : value);
                }}
                setSearchText={setSearchText}
            />

            <FlexMainWrapper>
                <MainTable
                    buttonComponents={({ checkItems }) => {}}
                    toggleBlur={true}
                    ref={ref}
                    tableStyle={{ width: chatParams.toggle ? '70%' : '98%' }}
                    tableRef={tableRef}
                    loadingText={'채팅 내역을 불러오고 있습니다.'}
                    headerData={gatheringChatFilter}
                    checkID={'id'}
                    param={param}
                    setParam={setParam}
                    callApi={callApi02}
                    onClickRowItem={(item) => async () => {
                        if (!item.room_id) return alert('대화방 ID가 없습니다.');
                        setChatParams({ toggle: true, chatId: item.room_id, gatheringName: item.gathering_name });
                    }}
                    tbodyRenderItem={(key, value, data) => {
                        const nullTag = <span style={{ color: '#797979' }}>정보없음</span>;
                        if (key === 'created_at') {
                            const timestamp = formatChatTimestamp(data.created_at);
                            return timestamp === '-' ? nullTag : timestamp;
                        }

                        if (key === 'avail_yn') return <div style={{ display: 'flex', justifyContent: 'center' }}>{availFilter(value)}</div>;
                        if (key === 'from') {
                            return (
                                <span>
                                    {data?.user_a_name} /{data?.user_a_nick_name} ({roleFilter(data.user_a_role)})
                                </span>
                            );
                        }
                        if (key === 'to') {
                            return (
                                <span>
                                    {data?.user_b_name} /{data?.user_b_nick_name} ({roleFilter(data.user_b_role)})
                                </span>
                            );
                        }
                        return value;
                    }}
                />
                {chatParams.toggle && (
                    <ChatModalComponent
                        toggle={chatParams.toggle}
                        closeModal={() => setChatParams({ toggle: false })}
                        header={<MText text={chatParams.gatheringName || '모임 1:1 대화방'} color="#000" />}
                        body={<ServerChatDetail chatId={chatParams.chatId} readOnly />}
                        inputOn={false}
                        boxStyle={{ paddingBottom: '10px' }}
                        bodyStyle={{ paddingBottom: '20px' }}
                    />
                )}
            </FlexMainWrapper>
        </Wrapper02>
    );
};

export default GatheringChat;
